<template>
    <academic>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <breeze-table :searchable="true" :fields="fields" :items="subjects" :action="{'text':'add subject','url':route('academic.subject.create')}" :searchlink="route('academic.subject.search')"  :canCreate="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Subject')" :canView="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Subject')">
                <template #status="data">
                    {{data.item.status?'Active':'Inactive'}}
                </template>
                <template #action="data">
                    <button-link :href="route('academic.subject.topic.list',data.item.id)"  class="mx-4" v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Edit Subject')">Topics</button-link>
                    <button-link v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Edit Subject')" :href="route('academic.subject.edit',data.item.id)" >Edit</button-link>
                </template>
            </breeze-table>
        </div>
    </academic>
</template>

<script>
    import Academic from '@/Pages/Academic/Academic'
    import BreezeTable from '@/Components/Table'
    import ButtonLink from '@/Components/ButtonLink'

    export default {
        components: {
            Academic,
            BreezeTable,
            ButtonLink
        },
        props:['subjects'],
        data(){
            return{
                fields:[{'key':'title','label':'Title'},{'key':'code','label':'Code'},{'key':'type','label':'Type'},{'key':'status','label':'Status'},{'key':'action','label':'Action'}]
            }
        }
    }
</script>
